module.exports = __webpack_public_path__ + "img/blank-profile.77f5794e.png";